import { render } from "./CardiovascularResults.vue?vue&type=template&id=ea6860a6"
import script from "./CardiovascularResults.vue?vue&type=script&lang=js"
export * from "./CardiovascularResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__